import Box from 'ui/src/components/Box'
import Button from 'ui/src/components/Button'
import Typography from 'ui/src/components/Typography'
import { useTranslation } from 'react-i18next'

import Header from './components/header'
import { Container } from './styles'
import { useNavigate } from 'react-router-dom'

interface IInternalErrorProps {
  resetErrorBoundary: () => void
  error: Error
}

const InternalError = ({ resetErrorBoundary, error }: IInternalErrorProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const exit = (navigateUrl: string) => {
    resetErrorBoundary()
    navigate(navigateUrl)
  }
  return (
    <div role="alert">
      <Header />
      <Container>
        <Box
          sx={{
            maxWidth: {
              xl: '754px',
              lg: '754px',
              md: '754px',
              sm: '600px',
              xs: '500px',
            },

            padding: { sm: 4, xs: 4 },
          }}
        >
          <Box
            sx={{
              borderRadius: 1,
              boxShadow: 1,
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: 'primary.contrastText',
              width: 'fit-content',
              p: 6,
            }}
          >
            <Typography
              sx={{
                fontSize: 34,
                fontWeight: 500,
                color: 'primary.main',
              }}
            >
              {t('internalError.wrong')}
            </Typography>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 400,
                color: '#9CA3AF',
              }}
            >
              {t('internalError.error')}: {error.message}
            </Typography>
            <Typography
              sx={{
                mt: 4,
                mb: 4,
                fontSize: 16,
                fontWeight: 400,
                color: '#1C2431',
              }}
            >
              {t('internalError.technicalDifficulties')}
            </Typography>
            <Typography
              sx={{
                mb: 4,
                fontSize: 16,
                fontWeight: 400,
                color: '#1C2431',
              }}
            >
              {t('internalError.thankYou')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                paddingTop: 3,
                gap: 2,
              }}
            >
              <Button sx={{ px: 3, py: 1.5 }} variant="outlined" onClick={() => exit('/concierge')}>
                {t('internalError.contactSupport')}
              </Button>
              <Button sx={{ px: 3, py: 1.5 }} variant="contained" onClick={() => exit('/')}>
                {t('default.backToHomePage')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </div>
  )
}

export default InternalError
